import template from './eventAddForm.html';
import controller from './eventAddForm.controller';
import './eventAddForm.scss';

let eventAddFormComponent = {
  restrict: 'E',
  bindings: {
    save: '&',
    racedayId: '<',
    locations: '<',
    storeFile: '&',
    removeFile: '&',
    event: '=',
    validation: '<'
  },
  template,
  controller
};

export default eventAddFormComponent;
